import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { aiAssistantActions } from '../../store/aiAssistantSlice';
import { selectIsStreaming, selectMessages } from '../../store/selectors';
import { ChatComposer } from './ChatComposer';

export function ChatInput() {
  const [value, setValue] = useState('');
  const dispatch = useDispatch();
  const isStreaming = useSelector(selectIsStreaming);
  const messages = useSelector(selectMessages);
  const isHero = messages.length === 0;

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || isStreaming) return;
    dispatch(aiAssistantActions.sendMessage(trimmed));
    setValue('');
  };

  const handleStop = () => {
    dispatch(aiAssistantActions.cancelStream());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  if (isHero) {
    return (
      <ChatComposer
        docked={false}
        value={value}
        onChange={setValue}
        onKeyDown={handleKeyDown}
        onSend={handleSend}
        onStop={handleStop}
        isStreaming={isStreaming}
        disabled={isStreaming}
        placeholder={isStreaming ? 'Waiting for response…' : 'Ask anything'}
        minRows={2}
      />
    );
  }

  return (
    <div className="rau-input-wrap rau-input-wrap--composer">
      {isStreaming && <div className="rau-input-progress" aria-hidden="true" />}
      <ChatComposer
        docked
        value={value}
        onChange={setValue}
        onKeyDown={handleKeyDown}
        onSend={handleSend}
        onStop={handleStop}
        isStreaming={isStreaming}
        disabled={isStreaming}
        placeholder={isStreaming ? 'Waiting for response…' : 'Ask anything'}
        minRows={1}
      />
    </div>
  );
}
